/**
 * Returns true if the key event is a "cancel" key -- either Escape or Backtick.
 * Backtick (`) serves as a universal Escape alternative for fullscreen laptop users,
 * where pressing Escape exits fullscreen mode.
 *
 * Usage: Replace `event.key === 'Escape'` with `isCancelKey(event)` in all
 * non-form-field keyboard handlers that treat Escape as cancel/dismiss/deselect.
 *
 * NOT used by form field blur handlers (TextField, NumberField, AngleField,
 * TextareaField, SliderNumberField, ToolOptionsBar) -- in form fields,
 * backtick types a literal ` character.
 */
export function isCancelKey(event: KeyboardEvent): boolean {
  return event.key === "Escape" || event.key === "`";
}
